var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthAndSafetyMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#001F97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 10V12.6667M11.9999 15.3333H12.0066M18.4866 16L13.1533 6.66665C13.037 6.46146 12.8684 6.29078 12.6646 6.17203C12.4608 6.05329 12.2291 5.99072 11.9933 5.99072C11.7574 5.99072 11.5258 6.05329 11.322 6.17203C11.1182 6.29078 10.9496 6.46146 10.8333 6.66665L5.49995 16C5.38241 16.2036 5.32077 16.4346 5.32129 16.6697C5.32181 16.9047 5.38447 17.1355 5.50292 17.3385C5.62136 17.5416 5.79138 17.7097 5.99575 17.8259C6.20011 17.942 6.43156 18.0021 6.66662 18H17.3333C17.5672 17.9997 17.797 17.938 17.9995 17.8208C18.202 17.7037 18.3701 17.5354 18.487 17.3327C18.6038 17.1301 18.6653 16.9002 18.6653 16.6663C18.6652 16.4324 18.6036 16.2026 18.4866 16Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthAndSafetyMarker);
export default __webpack_public_path__ + "static/media/HealthAndSafetyMarker.72a8de15793a0c81e0988ea9a095662e.svg";
export { ForwardRef as ReactComponent };